module.exports = __webpack_public_path__ + "img/9788956608082.66193161.jpg";